import $ from "jquery";
import { register } from "@shopify/theme-sections";

const selectors = {
	directionLink: "[data-booking-event-direction-link]",
	calendar: "[data-booking-event-calendar]",
	section: "[data-booking-events-section]"
};

const modifiers = {
	hidden: "hidden"
};

register("booking-events", {
	onLoad: function () {
		const sections = $(selectors.section);
		sections.each((_, section) => {
			const handle = $(section).attr("data-handle");
			if (handle === "true") return;
			const calendars = $(section).find(selectors.calendar);

			const closeOtherCalendars = () => {
				calendars.each((_, element) => {
					if (!$(element).hasClass(modifiers.hidden)) {
						$(element).addClass(modifiers.hidden);
					}
				});
			};

			$(section)
				.find(selectors.directionLink)
				.each((_, link) => {
					$(link).on("click", (event) => {
						event.preventDefault();
						const siblingCalendar = event.target.nextElementSibling;
						if ($(siblingCalendar).hasClass(modifiers.hidden)) {
							closeOtherCalendars();
							$(siblingCalendar).removeClass(modifiers.hidden);
						} else {
							$(siblingCalendar).addClass(modifiers.hidden);
						}
					});
				});
			$(section).attr("data-handle", "true");
		});
	}
});
